/** Chuẩn hóa mã ISO alpha-2 từ API eSIM. */
const CODE_ALIASES: Record<string, string> = {
  uk: "gb",
}

/** flagcdn chỉ phục vụ các width cố định — w44/w22 sẽ 404. */
const FLAGCDN_WIDTHS = [20, 40, 80, 160, 320, 640, 1280] as const

const snapFlagcdnWidth = (requested: number): number => {
  const clamped = Math.min(1280, Math.max(20, Math.round(requested)))
  return FLAGCDN_WIDTHS.reduce((best, candidate) =>
    Math.abs(candidate - clamped) < Math.abs(best - clamped) ? candidate : best,
  )
}

/**
 * Ảnh cờ PNG — hiển thị ổn trên Windows (emoji cờ thường không render).
 * @see https://flagcdn.com/
 */
export const getCountryFlagImageUrl = (
  countryCode?: string | null,
  width = 40,
): string | null => {
  const code = CODE_ALIASES[countryCode ?? ""] ?? countryCode
  if (!code) return null
  const w = snapFlagcdnWidth(width)
  return `https://flagcdn.com/w${w}/${code}.png`
}
/** Emoji cờ (iOS/Android/macOS); Windows thường không hiện. */
export const getCountryFlagEmoji = (countryCode?: string | null): string => {
  const code = CODE_ALIASES[countryCode ?? ""] ?? countryCode
  if (!code) return ""

  const codePoints = [...code.toUpperCase()].map(
    (letter) => 0x1f1e6 - 65 + letter.charCodeAt(0),
  )

  return String.fromCodePoint(...codePoints)
}
